export default __webpack_public_path__ + "static/0022-58626ab44468934690f95088552f4a55.png";